

// Rule condition action definition
class RuleConditionActionVM {
  uuid: string;
  item_id: string;
  action: string;
  options: {
    color?: string;
    [key: string]: any;
  };

  constructor(data?: Partial<RuleConditionActionVM>) {
    this.uuid = data?.uuid || ''
    this.item_id = data?.item_id || ''
    this.action = data?.action || ''
    this.options = data?.options || {}
  }
}

// Rule condition definition
class RuleConditionVM {
  uuid: string;
  type: string;
  children: any;
  rule?: any;
  related_items: string[];
  logic?: any;
  actions: RuleConditionActionVM[];

  constructor(data?: Partial<RuleConditionVM>) {
    this.uuid = data?.uuid || ''
    this.type = data?.type || ''
    this.children = data?.children || null
    this.rule = data?.rule
    this.related_items = data?.related_items || []
    this.logic = data?.logic
    this.actions = data?.actions ? data.actions.map(action => (action)) : []
  }
}

// Rule definition
class RuleVM {
  uuid: string;
  name: string;
  visibility: boolean;
  related_items: string[];
  rule_set_id: number;
  conditions: RuleConditionVM[];

  constructor(data?: Partial<RuleVM>) {
    this.uuid = data?.uuid || ''
    this.name = data?.name || ''
    this.visibility = data?.visibility || false
    this.related_items = data?.related_items || []
    this.rule_set_id = data?.rule_set_id || 0
    this.conditions = data?.conditions ? data.conditions.map(condition => (condition)) : []
  }
}

// Rule set definition
class RuleSetVM {
  uuid: string;
  has_visibility: boolean;
  related_items: string[];
  action_items: string[];
  rules: RuleVM[];

  constructor(data?: Partial<RuleSetVM>) {
    this.uuid = data?.uuid || ''
    this.has_visibility = data?.has_visibility || false
    this.related_items = data?.related_items || []
    this.action_items = data?.action_items || []
    this.rules = data?.rules ? data.rules.map(rule => (rule)) : []
  }
}

// Rule sets definition
class RuleSetsVM {
  [key: string]: RuleSetVM;

  constructor(data?: Record<string, RuleSetVM>) {
    if (data) {
      Object.keys(data).forEach(key => {
        this[key] = data[key] instanceof RuleSetVM ? data[key] : new RuleSetVM(data[key])
      })
    }
  }
}

export {RuleSetsVM, RuleVM, RuleSetVM, RuleConditionVM, RuleConditionActionVM}
